<a
  *ngIf="isTruncating && !isLast; else main"
  class="phx-breadcrumb-link"
  phx-tooltip
  phxTooltipSize="small"
  phxPlacement="bottom"
  [phxContent]="phxText"
  [routerLink]="routeLink"
  [tabIndex]="disabled ? -1 : 0"
>...</a>

<ng-template #main>
  <span
    *ngIf="isLast && isDefaultSize; else link"
    class="phx-breadcrumb-title"
    data-testid="breadcrumb-title"
    phx-tooltip-on-truncate
    phx-tooltip
    phxTooltipSize="small"
    phxPlacement="bottom"
    [phxContent]="phxText"
  >
    {{ phxText }}
  </span>

  <ng-template #link>
    <a
      class="phx-breadcrumb-link"
      [routerLink]="routeLink"
      [attr.aria-disabled]="disabled"
      [tabIndex]="disabled ? -1 : 0"
    >
      {{ phxText }}
    </a>
  </ng-template>
</ng-template>

<phx-badge
  *ngIf="!!phxBadgeText && isDefaultSize && !isTruncating && isLast"
  class="phx-breadcrumb-badge"
  [phxIntent]="phxBadgeIntent"
  [phxContrast]="phxBadgeContrast"
  [phxText]="phxBadgeText"
></phx-badge>

<span *ngIf="!isLast" class="phx-breadcrumb-separator">/</span>
